import { action, makeObservable, observable } from 'mobx';
import { getUserTimeZone } from 'utils/dateUtils';

class UIStore {
  isBurgerActive = false;
  isNotificationsActive = false;
  searchTerm = '';
  searchFilters = false;
  hasResults = false;
  duringSearch = false;
  showMessenger = false;
  userTimeZone = getUserTimeZone();

  constructor() {
    makeObservable(this, {
      isBurgerActive: observable,
      isNotificationsActive: observable,
      searchTerm: observable,
      duringSearch: observable,
      showMessenger: observable,
      userTimeZone: observable,

      setBurgerActive: action,
      setUserTimeZone: action,
      setNotificationsActive: action,
      setSearchStatus: action,
      setShowMessenger: action
    });
  }

  setBurgerActive(state?: boolean) {
    this.isBurgerActive = !!state;
  }

  setUserTimeZone(tz: string) {
    this.userTimeZone = tz;
  }

  setNotificationsActive(state?: boolean) {
    this.isNotificationsActive = state === undefined ? !this.isNotificationsActive : state;
  }

  setSearchStatus(
    searchTerm?: string,
    searchFilters?: boolean,
    duringSearch?: boolean,
    hasResults?: boolean
  ) {
    this.searchTerm = searchTerm || '';
    this.searchFilters = !!searchFilters;
    this.duringSearch = !!duringSearch;
    this.hasResults = !!hasResults;
  }

  setShowMessenger(state?: boolean) {
    this.showMessenger = state === undefined ? !this.showMessenger : state;
  }
}

export default UIStore;
